function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { forwardRef, useRef, useState, useCallback } from "react";
import { useAppActions, useAppState, MapLayer, PositionFocusState } from "~/map-interface/app-state";
import Map from "./map";
import { enable3DTerrain } from "./terrain";
import { GeolocateControl } from "mapbox-gl";
import hyper from "@macrostrat/hyper";
import { useEffect } from "react";
import useResizeObserver from "use-resize-observer";
import styles from "../main.module.styl";
import { useMapRef, CompassControl, GlobeControl, ThreeDControl, useMapConditionalStyle, useMapLabelVisibility, MapControlWrapper } from "@macrostrat/mapbox-react";
import classNames from "classnames";
import { debounce } from "underscore";
import { inDarkMode } from "@macrostrat/ui-components";
import { mapViewInfo, getMapPosition, setMapPosition, getMapboxStyle, mergeStyles } from "@macrostrat/mapbox-utils";
import { getExpressionForFilters } from "./filter-helpers";
import { MapSourcesLayer, mapStyle, toggleLineSymbols } from "../map-style";
import { SETTINGS } from "../../settings";
import mapboxgl from "mapbox-gl";
var h = hyper.styled(styles);
var VestigialMap = /*#__PURE__*/forwardRef(function (props, ref) {
  return h(Map, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  }));
});

function calcMapPadding(rect, childRect) {
  return {
    left: Math.max(rect.left - childRect.left, 0),
    top: Math.max(rect.top - childRect.top, 0),
    right: Math.max(childRect.right - rect.right, 0),
    bottom: Math.max(childRect.bottom - rect.bottom, 0)
  };
}

function ScaleControl(props) {
  var optionsRef = useRef({
    maxWidth: 200,
    unit: "metric"
  });
  return h(MapControlWrapper, _objectSpread({
    className: "map-scale-control",
    control: mapboxgl.ScaleControl,
    options: optionsRef.current
  }, props));
}

function GeolocationControl(props) {
  var optionsRef = useRef({
    showAccuracyCircle: true,
    showUserLocation: true,
    trackUserLocation: true,
    positionOptions: {
      enableHighAccuracy: true
    }
  });
  return h(MapControlWrapper, _objectSpread({
    control: GeolocateControl,
    options: optionsRef.current
  }, props));
}

function useElevationMarkerLocation(mapRef, elevationMarkerLocation) {
  // Handle elevation marker location
  useEffect(function () {
    var map = mapRef.current;
    if (map == null) return;
    if (elevationMarkerLocation == null) return;
    var src = map.getSource("elevationMarker");
    if (src == null) return;
    src.setData({
      type: "FeatureCollection",
      features: [{
        type: "Feature",
        properties: {},
        geometry: {
          type: "Point",
          coordinates: elevationMarkerLocation
        }
      }]
    });
  }, [mapRef, elevationMarkerLocation]);
}

function buildMapStyle(_x) {
  return _buildMapStyle.apply(this, arguments);
}

function _buildMapStyle() {
  _buildMapStyle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(baseMapURL) {
    var style;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getMapboxStyle(baseMapURL, {
              access_token: mapboxgl.accessToken
            });

          case 2:
            style = _context.sent;
            return _context.abrupt("return", mergeStyles(style, mapStyle));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _buildMapStyle.apply(this, arguments);
}

function initializeMap(_x2, _x3, _x4) {
  return _initializeMap.apply(this, arguments);
}

function _initializeMap() {
  _initializeMap = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(baseMapURL, mapPosition, infoMarkerPosition) {
    var map, focus;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // setup the basic map
            mapboxgl.accessToken = SETTINGS.mapboxAccessToken;
            _context2.t0 = mapboxgl.Map;
            _context2.next = 4;
            return buildMapStyle(baseMapURL);

          case 4:
            _context2.t1 = _context2.sent;
            _context2.t2 = {
              container: "map",
              style: _context2.t1,
              maxZoom: 18,
              logoPosition: "bottom-left",
              trackResize: true,
              antialias: true,
              optimizeForTerrain: true
            };
            map = new _context2.t0(_context2.t2);
            map.setProjection("globe"); // set initial map position

            setMapPosition(map, mapPosition);
            /* If we have an initially loaded info marker, we need to make sure
              that it is actually visible on the map, and move to it if not.
              This works around cases where the map is initialized with a hash string
              that contradicts the focused location (which would happen if the link was
              saved once the marker was moved out of view).
              */

            if (infoMarkerPosition != null) {
              focus = getFocusState(map, infoMarkerPosition);

              if (![PositionFocusState.CENTERED, PositionFocusState.NEAR_CENTER, PositionFocusState.OFF_CENTER].includes(focus)) {
                map.setCenter(infoMarkerPosition);
              }
            }

            return _context2.abrupt("return", map);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _initializeMap.apply(this, arguments);
}

function getMapPadding(ref, parentRef) {
  var _parentRef$current, _ref$current;

  var rect = (_parentRef$current = parentRef.current) === null || _parentRef$current === void 0 ? void 0 : _parentRef$current.getBoundingClientRect();
  var childRect = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getBoundingClientRect();
  if (rect == null || childRect == null) return;
  return calcMapPadding(rect, childRect);
}

function MapContainer(props) {
  var _useAppState = useAppState(function (state) {
    return state.core;
  }),
      filters = _useAppState.filters,
      filteredColumns = _useAppState.filteredColumns,
      mapLayers = _useAppState.mapLayers,
      mapCenter = _useAppState.mapCenter,
      elevationChartOpen = _useAppState.elevationChartOpen,
      elevationData = _useAppState.elevationData,
      elevationMarkerLocation = _useAppState.elevationMarkerLocation,
      mapPosition = _useAppState.mapPosition,
      infoDrawerOpen = _useAppState.infoDrawerOpen,
      mapSettings = _useAppState.mapSettings;

  var mapIsLoading = useAppState(function (state) {
    return state.core.mapIsLoading;
  });
  var runAction = useAppActions();
  /* HACK: Right now we need this to force a render when the map
    is done loading
    */

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      mapInitialized = _useState2[0],
      setMapInitialized = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      styleLoaded = _useState4[0],
      setStyleLoaded = _useState4[1];

  var mapRef = useMapRef();
  var ref = useRef();
  var parentRef = useRef();

  var _mapViewInfo = mapViewInfo(mapPosition),
      mapUse3D = _mapViewInfo.mapUse3D,
      mapIsRotated = _mapViewInfo.mapIsRotated;

  var isDarkMode = inDarkMode();
  var baseMapURL = getBaseMapStyle(mapLayers, isDarkMode);

  var _useState5 = useState(getMapPadding(ref, parentRef)),
      _useState6 = _slicedToArray(_useState5, 2),
      padding = _useState6[0],
      setPadding = _useState6[1];

  var infoMarkerPosition = useAppState(function (state) {
    return state.core.infoMarkerPosition;
  });
  var hasLineSymbols = mapLayers.has(MapLayer.LINE_SYMBOLS) && mapLayers.has(MapLayer.LINES);
  var updateMapPadding = useCallback(function () {
    setPadding(getMapPadding(ref, parentRef));
  }, [ref, parentRef]);
  useEffect(function () {
    initializeMap(baseMapURL, mapPosition, infoMarkerPosition).then(function (map) {
      mapRef.current = map;

      if (!map.isStyleLoaded()) {
        map.once("style.load", function () {
          setStyleLoaded(true);
        });
      } else {
        setStyleLoaded(true);
      }
      /* Right now we need to reload filters when the map is initialized.
         Otherwise our (super-legacy and janky) filter system doesn't know
         to update the map. */
      //runAction({ type: "set-filters", filters: [...filters] });


      setMapInitialized(true); // Update map padding on load

      updateMapPadding();
      toggleLineSymbols(map, hasLineSymbols);
    });
  }, []);
  /* If we want to use a high resolution DEM, we need to use a different
    source ID from the hillshade's source ID. This uses more memory but
    provides a nicer-looking 3D map.
    */

  var demSourceID = mapSettings.highResolutionTerrain ? "mapbox-3d-dem" : null;
  useEffect(function () {
    if (mapRef.current == null) return;
    buildMapStyle(baseMapURL).then(function (style) {
      mapRef.current.setStyle(style);
      enable3DTerrain(mapRef.current, mapUse3D, demSourceID);
    });
  }, [baseMapURL, demSourceID]);
  useEffect(function () {
    var map = mapRef.current;
    if (map == null) return;
    enable3DTerrain(map, mapUse3D, demSourceID);
  }, [mapRef.current, mapUse3D]);
  var markerRef = useRef(null);
  var handleMapQuery = useMapQueryHandler(mapRef, markerRef, infoDrawerOpen);
  useMapEaseToCenter(padding);
  useMapMarker(mapRef, markerRef, infoMarkerPosition);
  /* Update columns map layer given columns provided by application. */

  var allColumns = useAppState(function (state) {
    return state.core.allColumns;
  });
  useEffect(function () {
    var _allColumns$length;

    var map = mapRef.current;
    var ncols = (_allColumns$length = allColumns === null || allColumns === void 0 ? void 0 : allColumns.length) !== null && _allColumns$length !== void 0 ? _allColumns$length : 0;
    if (map == null || ncols == 0) return; // Set source data for columns

    map.once("style.load", function () {
      var src = map.getSource("columns");
      if (src == null) return;
      src.setData({
        type: "FeatureCollection",
        features: allColumns !== null && allColumns !== void 0 ? allColumns : []
      });
    });
    var src = map.getSource("columns");
    if (src == null) return;
    src.setData({
      type: "FeatureCollection",
      features: allColumns !== null && allColumns !== void 0 ? allColumns : []
    });
  }, [mapRef.current, allColumns, mapInitialized]);
  useEffect(function () {
    // Get the current value of the map. Useful for gradually moving away
    // from class component
    var map = mapRef.current;
    if (map == null) return; // Update the URI when the map moves

    var mapMovedCallback = function mapMovedCallback() {
      var marker = markerRef.current;
      var map = mapRef.current;
      runAction({
        type: "map-moved",
        data: {
          mapPosition: getMapPosition(map),
          infoMarkerFocus: getFocusState(map, marker === null || marker === void 0 ? void 0 : marker.getLngLat())
        }
      });
    };

    mapMovedCallback();
    map.on("moveend", debounce(mapMovedCallback, 100));
  }, [mapInitialized]);
  useEffect(function () {
    if (mapLayers.has(MapLayer.COLUMNS)) {
      runAction({
        type: "get-filtered-columns"
      });
    }

    runAction({
      type: "map-layers-changed",
      mapLayers: mapLayers
    });
  }, [filters, mapLayers]);
  useEffect(function () {
    var map = mapRef.current;
    if (map == null || !mapInitialized || !styleLoaded) return;
    var expr = getExpressionForFilters(filters);
    map.setFilter("burwell_fill", expr);
    map.setFilter("burwell_stroke", expr);
  }, [filters, mapInitialized, styleLoaded]);
  useMapLabelVisibility(mapRef, mapLayers.has(MapLayer.LABELS));
  useEffect(function () {
    var map = mapRef.current;
    if (map == null) return;
    map.on("idle", function () {
      if (!mapIsLoading) return;
      runAction({
        type: "map-idle"
      });
    });
  }, [mapRef.current, mapIsLoading]);
  useMapConditionalStyle(mapRef, hasLineSymbols, toggleLineSymbols);
  useResizeObserver({
    ref: parentRef,
    onResize: function onResize(sz) {
      updateMapPadding();
    }
  });
  var debouncedResize = useRef(debounce(function () {
    var _mapRef$current;

    (_mapRef$current = mapRef.current) === null || _mapRef$current === void 0 ? void 0 : _mapRef$current.resize();
  }, 100));
  useResizeObserver({
    ref: ref,
    onResize: debouncedResize.current
  });
  useElevationMarkerLocation(mapRef, elevationMarkerLocation);
  var className = classNames({
    "is-rotated": mapIsRotated !== null && mapIsRotated !== void 0 ? mapIsRotated : false,
    "is-3d-available": mapUse3D !== null && mapUse3D !== void 0 ? mapUse3D : false
  });
  return h("div.map-view-container.main-view", {
    ref: parentRef
  }, [h("div.mapbox-map#map", {
    ref: ref,
    className: className
  }), h(VestigialMap, _objectSpread(_objectSpread({
    filters: filters,
    filteredColumns: filteredColumns,
    // Recreate the set every time to force a re-render
    mapLayers: mapLayers,
    mapCenter: mapCenter,
    elevationChartOpen: elevationChartOpen,
    elevationData: elevationData,
    elevationMarkerLocation: elevationMarkerLocation,
    mapPosition: mapPosition,
    mapIsLoading: mapIsLoading,
    mapIsRotated: mapIsRotated,
    onQueryMap: handleMapQuery,
    mapRef: mapRef,
    isDark: isDarkMode,
    runAction: runAction
  }, props), {}, {
    ref: ref
  })), h["if"](mapLayers.has(MapLayer.SOURCES))(MapSourcesLayer)]);
}

function useMapQueryHandler(mapRef, markerRef, infoDrawerOpen) {
  /** Handler for map query markers */
  var runAction = useAppActions();
  return useCallback(function (event) {
    var _markerRef$current;

    var columns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var column = columns === null || columns === void 0 ? void 0 : columns[0];
    var map = mapRef.current;
    runAction({
      type: "map-query",
      lng: event.lngLat.lng,
      lat: event.lngLat.lat,
      z: map.getZoom(),
      column: column,
      map_id: null
    });
    var marker = (_markerRef$current = markerRef.current) !== null && _markerRef$current !== void 0 ? _markerRef$current : new mapboxgl.Marker({
      color: "#000000"
    });
    marker.setLngLat(event.lngLat).addTo(mapRef.current);
    markerRef.current = marker;
  }, [mapRef, markerRef, infoDrawerOpen]);
}

export function MapBottomControls() {
  return h("div.map-controls", [h(ScaleControl), h(ThreeDControl, {
    className: "map-3d-control"
  }), h(CompassControl, {
    className: "compass-control"
  }), h(GlobeControl, {
    className: "globe-control"
  }), h(GeolocationControl, {
    className: "geolocation-control"
  })]);
}
export function MapStyledContainer(_ref) {
  var className = _ref.className,
      children = _ref.children;
  var mapPosition = useAppState(function (state) {
    return state.core.mapPosition;
  });

  if (mapPosition != null) {
    var _mapViewInfo2 = mapViewInfo(mapPosition),
        mapIsRotated = _mapViewInfo2.mapIsRotated,
        mapUse3D = _mapViewInfo2.mapUse3D,
        mapIsGlobal = _mapViewInfo2.mapIsGlobal;

    className = classNames(className, {
      "map-is-rotated": mapIsRotated,
      "map-3d-available": mapUse3D,
      "map-is-global": mapIsGlobal
    });
  }

  return h("div", {
    className: className
  }, children);
}

function getBaseMapStyle(mapLayers) {
  var isDarkMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (mapLayers.has(MapLayer.SATELLITE)) {
    return SETTINGS.satelliteMapURL;
  }

  if (isDarkMode) {
    return SETTINGS.darkMapURL;
  }

  return SETTINGS.baseMapURL;
}

function useMapMarker(mapRef, markerRef, markerPosition) {
  useEffect(function () {
    var _markerRef$current3;

    var map = mapRef.current;
    if (map == null) return;

    if (markerPosition == null) {
      var _markerRef$current2;

      (_markerRef$current2 = markerRef.current) === null || _markerRef$current2 === void 0 ? void 0 : _markerRef$current2.remove();
      return;
    }

    var marker = (_markerRef$current3 = markerRef.current) !== null && _markerRef$current3 !== void 0 ? _markerRef$current3 : new mapboxgl.Marker();
    marker.setLngLat(markerPosition).addTo(map);
    markerRef.current = marker;
    return function () {
      return marker.remove();
    };
  }, [mapRef.current, markerPosition]);
}

function useMapEaseToCenter(padding) {
  var mapRef = useMapRef();
  var infoMarkerPosition = useAppState(function (state) {
    return state.core.infoMarkerPosition;
  });
  var prevInfoMarkerPosition = useRef(null);
  var prevPadding = useRef(null); // Handle map position easing (for both map padding and markers)

  useEffect(function () {
    var map = mapRef.current;
    if (map == null) return;
    var opts = null;

    if (infoMarkerPosition != prevInfoMarkerPosition.current) {
      var _opts;

      (_opts = opts) !== null && _opts !== void 0 ? _opts : opts = {};
      opts.center = infoMarkerPosition;
    }

    if (padding != prevPadding.current) {
      var _opts2;

      (_opts2 = opts) !== null && _opts2 !== void 0 ? _opts2 : opts = {};
      opts.padding = padding;
    }

    if (opts == null) return;
    opts.duration = 800;
    map.flyTo(opts);
    map.once("moveend", function () {
      /* Waiting until moveend to update the refs allows us to
      batch overlapping movements together, which increases UI
      smoothness when, e.g., flying to new panels */
      prevInfoMarkerPosition.current = infoMarkerPosition;
      prevPadding.current = padding;
    });
  }, [infoMarkerPosition, padding]);
}

function getFocusState(map, location) {
  /** Determine whether the infomarker is positioned in the viewport */
  if (location == null) return null;
  var markerPos = map.project(location);
  var mapPos = map.project(map.getCenter());
  var dx = Math.abs(markerPos.x - mapPos.x);
  var dy = Math.abs(markerPos.y - mapPos.y);
  var padding = map.getPadding();

  var _map$getCanvas = map.getCanvas(),
      width = _map$getCanvas.width,
      height = _map$getCanvas.height;

  width /= 2;
  height /= 2;

  if (dx < 10 && dy < 10) {
    return PositionFocusState.CENTERED;
  }

  if (dx < 150 && dy < 150) {
    return PositionFocusState.NEAR_CENTER;
  }

  if (markerPos.x > padding.left && markerPos.x < width - padding.right && markerPos.y > padding.top && markerPos.y < height - padding.bottom) {
    return PositionFocusState.OFF_CENTER;
  }

  if (markerPos.x > 0 && markerPos.x < width && markerPos.y > 0 && markerPos.y < height) {
    return PositionFocusState.OUT_OF_PADDING;
  }

  return PositionFocusState.OUT_OF_VIEW;
}

export default MapContainer;